export default __webpack_public_path__ + "static/media/active.b1364092.svg";